import {
  type ActionRegisterDeviceSucceeded,
  type ActionRegisteringDevice,
  REGISTERING_DEVICE,
  REGISTER_DEVICE_SUCCEEDED,
} from '~shared/actions/devices';
import { withRehydration } from '~shared/reducers/withRehydration';
import { type Device } from '~shared/types';

type PartialDevice = {
  push_token: Device['push_token'];
  id?: Device['id'];
  isThisDevice: boolean;
};

export type StateDevices = {
  devices: PartialDevice[];
};

export const initialState: StateDevices = {
  devices: [],
};

type Action = ActionRegisteringDevice | ActionRegisterDeviceSucceeded;

const devices = (state: StateDevices = initialState, action: Action): StateDevices => {
  const { type, payload } = action;
  const { devices } = state;

  switch (type) {
    case REGISTERING_DEVICE: {
      const isPresent = !!devices.find(({ push_token }) => {
        return push_token === payload.push_token;
      });
      return isPresent ? state : { ...state, devices: [...devices, { ...payload, isThisDevice: true }] };
    }

    case REGISTER_DEVICE_SUCCEEDED: {
      const index = devices.findIndex(({ push_token }) => {
        return push_token === payload.push_token;
      });
      const newDevicesState = [...devices];

      if (index > -1) {
        newDevicesState[index] = { ...newDevicesState[index], ...payload };
      }

      return { ...state, devices: newDevicesState };
    }

    default:
      return state;
  }
};

export default withRehydration(devices, initialState);
